export const IDLE_REFRESH_TIMEOUT_MS = 60 * 60 * 1000;
